/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Certbadge_Err_Name_Long1Inputs */

const vi_certbadge_err_name_long1 = /** @type {(inputs: Certbadge_Err_Name_Long1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tên logo tối đa ${i?.max} ký tự`)
};

/**

* @param {Certbadge_Err_Name_Long1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const certbadge_err_name_long1 = /** @type {((inputs: Certbadge_Err_Name_Long1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Certbadge_Err_Name_Long1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_certbadge_err_name_long1(inputs)
});
export { certbadge_err_name_long1 as "certBadge_err_name_long" }